import { collection, getDocs, query, where } from "firebase/firestore";
import { samplePublicBanquetDemo } from "../data/samplePublicBanquetDemo.js";
import { db } from "../firebase.js";
import { normalizeBanquet } from "../features/banquetOwnerPanel/model/banquetModel.js";
import { PUBLIC_BANQUET_STATUSES, isPubliclyVisibleBanquet } from "../utils/banquetPublication.js";

const banquetCollectionRef = collection(db, "banquets");

const addressToText = (address) => {
  if (!address) {
    return "";
  }

  if (typeof address === "string") {
    return address;
  }

  return [address.line1, address.line2, address.pincode].filter(Boolean).join(", ");
};

const toPublicBanquet = (snapshot) => {
  const banquet = normalizeBanquet({
    id: snapshot.id,
    ...snapshot.data(),
  });

  return {
    ...banquet,
    address: addressToText(banquet.address),
    city: banquet.city || banquet.locationDetails?.city || "",
    locality: banquet.locality || banquet.locationDetails?.locality || "",
    area: banquet.area || banquet.locationDetails?.locality || "",
    pincode: banquet.pincode || banquet.address?.pincode || "",
    mapUrl: banquet.mapUrl || banquet.googleMapsUrl || "#",
    latitude: banquet.latitude ?? banquet.locationDetails?.latitude ?? null,
    longitude: banquet.longitude ?? banquet.locationDetails?.longitude ?? null,
    slug: banquet.slug || banquet.id,
    shortDescription: banquet.shortDescription || banquet.description || "",
    images: banquet.images?.length ? banquet.images : [banquet.coverImage].filter(Boolean),
  };
};

const withSamplePublicListing = (banquets) => {
  const sampleListingExists = banquets.some(
    (banquet) => banquet.id === samplePublicBanquetDemo.id || banquet.slug === samplePublicBanquetDemo.slug
  );

  return sampleListingExists ? banquets : [samplePublicBanquetDemo, ...banquets];
};

export const getPublishedBanquets = async () => {
  const snapshot = await getDocs(
    query(
      banquetCollectionRef,
      where("status", "in", PUBLIC_BANQUET_STATUSES),
      where("isActive", "==", true)
    )
  );

  const publishedBanquets = snapshot.docs
    .map(toPublicBanquet)
    .filter(isPubliclyVisibleBanquet);

  return withSamplePublicListing(publishedBanquets).filter(isPubliclyVisibleBanquet);
};

export const getPublishedBanquetBySlug = async (slug) => {
  const banquets = await getPublishedBanquets();
  return banquets.find((banquet) => banquet.slug === slug || banquet.id === slug) || null;
};
